import React from 'react';

import { postRequest } from 'utils/api';
import { useDispatch } from 'react-redux';
import { setGig } from 'features/gigsSlice';
import FollowIcon from 'components/FollowIcon';

const FollowGig = ({ gig, updateGig, circleHeart = false }) => {
  const dispatch = useDispatch();

  const handleFollow = () => {
    postRequest({ endpoint: `gigs/${gig.id}/follow` })
      .then(() => {
        const updatedGig = { ...gig, following: true };

        dispatch(setGig(updatedGig));
        updateGig(updatedGig);
      })
      .catch(() => {});
  };

  const handleUnfollow = () => {
    postRequest({ endpoint: `gigs/${gig.id}/unfollow` })
      .then(() => {
        const updatedGig = { ...gig, following: false };

        dispatch(setGig(updatedGig));
        updateGig(updatedGig);
      })
      .catch(() => {});
  };

  return (
    <FollowIcon
      circleHeart={circleHeart}
      following={gig.following}
      handleFollow={handleFollow}
      handleUnfollow={handleUnfollow}
    />
  );
};

export default FollowGig;
